import { Field } from "../../../components/form/models/models";
import {
  showAdvisoryTextSectionF,
  showAdvisoryTextSectionG,
  showAdvisoryTextSectionH,
  showAdvisoryTextSectionI,
  showAdvisoryTextSectionP,
  showAdvisoryTextSectionR,
} from "./formValidation/kindergartenAdvisoryValidation";

export const screeningAdvisoryText: Field[] = [
  {
    type: "field",
    key: "advisory15",
    fieldType: "advisory",
    hideExpression: (context, values) =>
      !showAdvisoryTextSectionF(context, values) ||
      (values.applicationBase != null
        ? !(values.applicationBase.screeningQuestions.fundedKinder.consentYes.screeningApplicationType == 1)
        : !(values.fundedKinder.consentYes.screeningApplicationType == 1)),
    props: {
      type: "warning",
      Body: () => (
        <div className="list-none pl-2 m-0">
          <p className="mb-2">
            {import.meta.env.VITE_NVI == "kappa" && <p>Advisory F</p>}
            Thank you for completing application pre-screening. Based on your responses, the child may be eligible for the KIS program and you can now
            begin your application.
            <br />
          </p>

          <p className="mb-2">
            {" "}
            To continue, you will need to provide some basic information about the child and your kindergarten service to create the application. Once
            these fields are completed, the KIS portal will create an application record for the child, which will display when you log into the KIS
            portal. You can come back and complete the rest of the application at any time, it does not need to be finished in one session.
            <br />{" "}
          </p>
          <p>
            To check what documents you may need to upload for this application, please refer to the{" "}
            <a
              href="https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/Application-completion-checklist.pdf"
              target="_blank"
              title="Link opens in a new tab"
              rel="noreferrer">
              KIS application completion checklist
            </a>
            . <i aria-hidden="true" className="pi pi-external-link"></i>
          </p>
        </div>
      ),
    },
    label: "",
  },
  {
    type: "field",
    key: "advisory16",
    fieldType: "advisory",
    hideExpression: (context, values) =>
      !showAdvisoryTextSectionG(context, values) ||
      (values.applicationBase != null
        ? !(values.applicationBase.screeningQuestions.fundedKinder.consentYes.screeningApplicationType == 1)
        : !(values.fundedKinder.consentYes.screeningApplicationType == 1)),
    props: {
      type: "warning",
      Body: (model: any) => (
        <div>
          {import.meta.env.VITE_NVI == "kappa" && <p>Advisory G</p>}
          <p className="m-0">
            Thank you for completing application pre-screening. Based on your responses, the child cannot be assessed for eligibility under the KIS
            program due to the following reason(s):
          </p>
          {model.parentvalues.applicationCategory === 3 && model.parentvalues.complexMedicalNeedsCriteria == 2 && (
            <ul className="pl-3 indentation">
              <li>
                To apply for the KIS program under the complex medical needs stream, you must be able to upload suitable evidence that the child has
                complex medical needs, which require a high level of individualised healthcare supports.{" "}
                <p className="mb-0">Applications require the following to be submitted:</p>{" "}
                <ul className="pl-3 ml-6 indentation">
                  <li>evidence of a medical diagnosis from a medical practitioner</li>
                  <li>a medical management plan (MMP) and</li>
                  <li>a risk minimisation plan </li>
                </ul>
                <p className="m-0">
                  {" "}
                  Until the kindergarten has this information, an application cannot be lodged. You can read more about the evidence required in the
                  KIS{" "}
                  <a
                    href="https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-Program-%E2%80%93-Guidelines-for-the-Disability-and-Complex-Medical-Needs-streams.pdf"
                    target="_blank"
                    title="Link opens in a new tab"
                    rel="noreferrer">
                    guidelines
                  </a>
                  . <i aria-hidden="true" className="pi pi-external-link"></i>
                </p>
              </li>
            </ul>
          )}
          <ul className="indentation">
            {(model.parentvalues.applicationCategory === 1 || model.parentvalues.applicationCategory === 2) &&
              model.parentvalues.childsDisability.childsDisabilityNone && (
                <li>
                  {" "}
                  {import.meta.env.VITE_NVI == "kappa" && "K "}
                  For a child to be eligible for support under the KIS program disability stream, they either must be a significant risk of serious
                  injury to themselves and/or others, or have an extremely restricted capacity for movement.
                </li>
              )}
            {(model.parentvalues.applicationCategory === 1 || model.parentvalues.applicationCategory === 2) &&
              model.parentvalues.childDiagnosedDisability == 3 && (
                <li>
                  {import.meta.env.VITE_NVI == "kappa" && "L "} For a child to be eligible for support under the KIS program disability stream, the
                  child must either have a disability diagnosis, or be undertaking ongoing assessment for a disability. Based on the responses you
                  have provided, this child does not appear to be eligible for the KIS program.
                </li>
              )}
            {(model.parentvalues.applicationCategory === 1 || model.parentvalues.applicationCategory === 2) &&
              model.parentvalues.childDiagnosedDisability != null &&
              model.parentvalues.childDiagnosedDisability === 1 &&
              model.parentvalues.typeOfDiagnosedDisabilityEvidence != null &&
              model.parentvalues.typeOfDiagnosedDisabilityEvidence === 4 && (
                <li>
                  {import.meta.env.VITE_NVI == "kappa" && "M "}For a child to be eligible for support under the KIS program disability stream, you
                  must be able to upload suitable evidence of the child's diagnosis or disability. Until the kindergarten has this information, an
                  application cannot be lodged. You can read more about the evidence required in the{" "}
                  <a
                    href="http://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-Program-–-Guidelines-for-the-Disability-and-Complex-Medical-Needs-streams.pdf"
                    target="_blank"
                    title="Link opens in a new tab"
                    rel="noreferrer">
                    KIS guidelines
                  </a>
                  . <i aria-hidden="true" className="pi pi-external-link"></i>
                </li>
              )}
            {(model.parentvalues.applicationCategory === 1 || model.parentvalues.applicationCategory === 2) &&
              model.parentvalues.childDiagnosedDisability != null &&
              model.parentvalues.childDiagnosedDisability === 2 &&
              model.parentvalues.evidenceUndergoingAssessment != null &&
              model.parentvalues.evidenceUndergoingAssessment === 3 && (
                <li>
                  {import.meta.env.VITE_NVI == "kappa" && "N "}For a child to be eligible for support under the KIS program disability stream, you
                  must be able to upload suitable evidence that the child is undergoing diagnosis for a disability. Until the kindergarten has this
                  information, an application cannot be lodged. You can read more about the evidence required in the{" "}
                  <a
                    href="http://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-Program-–-Guidelines-for-the-Disability-and-Complex-Medical-Needs-streams.pdf"
                    target="_blank"
                    title="Link opens in a new tab"
                    rel="noreferrer">
                    KIS guidelines
                  </a>
                  . <i aria-hidden="true" className="pi pi-external-link"></i>
                </li>
              )}
            {(model.parentvalues.applicationCategory === 1 || model.parentvalues.applicationCategory === 2) &&
              model.parentvalues.kisPlanCompleted != null &&
              model.parentvalues.kisPlanCompleted === 2 && (
                <li>
                  {import.meta.env.VITE_NVI == "kappa" && "O "} An application for support under the disability stream of the KIS program cannot be
                  submitted without first completing or updating a KIS plan for the child within the last 3 months. Please see the{" "}
                  <a
                    href="http://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-Program-–-Guidelines-for-the-Disability-and-Complex-Medical-Needs-streams.pdf"
                    target="_blank"
                    title="Link opens in a new tab"
                    rel="noreferrer">
                    KIS guidelines
                  </a>{" "}
                  <i aria-hidden="true" className="pi pi-external-link"></i> for further information.
                </li>
              )}
          </ul>{" "}
        </div>
      ),
    },
    label: "",
  },
  {
    type: "field",
    key: "advisory17",
    fieldType: "advisory",
    hideExpression: (context, values) =>
      !showAdvisoryTextSectionH(context, values) ||
      (values.applicationBase != null
        ? !(values.applicationBase.screeningQuestions.fundedKinder.consentYes.screeningApplicationType == 1)
        : !(values.fundedKinder.consentYes.screeningApplicationType == 1)),
    props: {
      type: "warning",
      Body: () => (
        <div className="list-none pl-2 m-0">
          {import.meta.env.VITE_NVI == "kappa" && <p>Advisory H</p>}
          Thank you for completing application pre-screening. Based on your responses, the child cannot be assessed for eligibility under the complex
          medical needs stream due to the following reason:
          <div className="flex">
            <ul className="pl-3 mb-0 indentation">
              <li>
                To apply for the KIS program under the complex medical needs stream, you must be able to upload suitable evidence that the child has
                complex medical needs, which require a high level of individualised healthcare supports.
                <p className="mb-0">Applications require the following to be submitted: </p>
                <ul className="pl-3 m-0 ml-6 indentation">
                  <li> evidence of a medical diagnosis from a medical practitioner</li>
                  <li> a medical management plan (MMP) and</li>
                  <li> a risk minimisation plan </li>
                </ul>
                <p>
                  {" "}
                  Until the kindergarten has this information, an application cannot be lodged. You can read more about the evidence required in the
                  KIS{" "}
                  <a
                    href="https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-Program-%E2%80%93-Guidelines-for-the-Disability-and-Complex-Medical-Needs-streams.pdf"
                    target="_blank"
                    title="Link opens in a new tab"
                    rel="noreferrer">
                    guidelines
                  </a>
                  . <i aria-hidden="true" className="pi pi-external-link"></i>
                </p>
              </li>
            </ul>
          </div>
          <p className="mt-0">
            {" "}
            However, while the child cannot be assessed for eligibility under the complex medical needs stream, the child may be eligible under the
            disability stream.
          </p>
          <strong>
            If you would like to continue this application, please note that the child will be assessed against the disability eligibility criteria
            only.
          </strong>
          <p>
            To continue, you will need to provide some basic information about the child and your kindergarten service to create the application. Once
            these fields are completed, the KIS portal will create an application record for the child, which will display when you log into the KIS
            portal. You can come back and complete the rest of the application at any time, it does not need to be finished in one session.
          </p>
          <p> To check what documents you may need to upload for this application, please refer to the KIS application completion checklist.</p>
        </div>
      ),
    },
    label: "",
  },
  {
    type: "field",
    key: "advisory18",
    fieldType: "advisory",
    hideExpression: (context, values) =>
      !showAdvisoryTextSectionI(context, values) ||
      (values.applicationBase != null
        ? !(values.applicationBase.screeningQuestions.fundedKinder.consentYes.screeningApplicationType == 1)
        : !(values.fundedKinder.consentYes.screeningApplicationType == 1)),
    props: {
      type: "warning",
      Body: (model: any) => (
        <ul className="pl-2 m-0 indentation">
          {import.meta.env.VITE_NVI == "kappa" && <p>Advisory I</p>}
          Thank you for completing application pre-screening. Based on your responses, the child cannot be assessed for eligibility under the
          disability stream due to the following reason(s):
          {(model.parentvalues.applicationCategory === 2 || model.parentvalues.applicationCategory === 3) &&
            model.parentvalues.childsDisability.childsDisabilityNone && (
              <li className="ml-5">
                {import.meta.env.VITE_NVI == "kappa" && "K "} For a child to be eligible for support under the KIS program disability stream, they
                either must be a significant risk of serious injury to themselves and/or others, or have an extremely restricted capacity for
                movement.
              </li>
            )}
          {(model.parentvalues.applicationCategory === 2 || model.parentvalues.applicationCategory === 3) &&
            model.parentvalues.childDiagnosedDisability == 3 && (
              <li className="ml-5">
                {import.meta.env.VITE_NVI == "kappa" && "L "} For a child to be eligible for support under the KIS program disability stream, the
                child must either have a disability diagnosis, or be undertaking ongoing assessment for a disability. Based on the responses you have
                provided, this child does not appear to be eligible for the KIS program.
              </li>
            )}
          {(model.parentvalues.applicationCategory === 2 || model.parentvalues.applicationCategory === 3) &&
            model.parentvalues.childDiagnosedDisability != null &&
            model.parentvalues.childDiagnosedDisability === 1 &&
            model.parentvalues.typeOfDiagnosedDisabilityEvidence != null &&
            model.parentvalues.typeOfDiagnosedDisabilityEvidence === 4 && (
              <li className="ml-5">
                {import.meta.env.VITE_NVI == "kappa" && "M "} For a child to be eligible for support under the KIS program disability stream, you must
                be able to upload suitable evidence of the child's diagnosis or disability. Until the kindergarten has this information, an
                application cannot be lodged. You can read more about the evidence required in the{" "}
                <a
                  href="http://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-Program-–-Guidelines-for-the-Disability-and-Complex-Medical-Needs-streams.pdf"
                  target="_blank"
                  title="Link opens in a new tab"
                  rel="noreferrer">
                  KIS guidelines
                </a>
                . <i aria-hidden="true" className="pi pi-external-link"></i>
              </li>
            )}
          {(model.parentvalues.applicationCategory === 2 || model.parentvalues.applicationCategory === 3) &&
            model.parentvalues.childDiagnosedDisability != null &&
            model.parentvalues.childDiagnosedDisability === 2 &&
            model.parentvalues.evidenceUndergoingAssessment != null &&
            model.parentvalues.evidenceUndergoingAssessment === 3 && (
              <li className="ml-5">
                {import.meta.env.VITE_NVI == "kappa" && "N "} For a child to be eligible for support under the KIS program disability stream, you must
                be able to upload suitable evidence that the child is undergoing diagnosis for a disability. Until the kindergarten has this
                information, an application cannot be lodged. You can read more about the evidence required in the{" "}
                <a
                  href="http://www.ahaconsulting.com.au/wp-content/uploads/2025/08/KIS-Program-–-Guidelines-for-the-Disability-and-Complex-Medical-Needs-streams.pdf"
                  target="_blank"
                  title="Link opens in a new tab"
                  rel="noreferrer">
                  KIS guidelines
                </a>
                . <i aria-hidden="true" className="pi pi-external-link"></i>
              </li>
            )}
          {(model.parentvalues.applicationCategory === 2 || model.parentvalues.applicationCategory === 3) &&
            model.parentvalues.kisPlanCompleted != null &&
            model.parentvalues.kisPlanCompleted === 2 && (
              <li className="ml-5">
                {import.meta.env.VITE_NVI == "kappa" && "O "}An application for support under the disability stream of the KIS program cannot be
                submitted without first completing or updating a KIS plan for the child within the last 3 months. Please see the KIS guidelines for
                further information.
              </li>
            )}
        </ul>
      ),
    },
    label: "",
  },
  {
    type: "field",
    key: "advisory19",
    fieldType: "advisory",
    hideExpression: (context, values) =>
      !showAdvisoryTextSectionP(context, values) ||
      (values.applicationBase != null
        ? !(values.applicationBase.screeningQuestions.fundedKinder.consentYes.screeningApplicationType == 1)
        : !(values.fundedKinder.consentYes.screeningApplicationType == 1)),
    props: {
      type: "warning",
      Body: () => (
        <div className="list-none pl-2 m-0">
          {import.meta.env.VITE_NVI == "kappa" && (
            <p>
              Advisory P <br />
            </p>
          )}
          Although the child cannot currently be assessed for eligibility under the KIS program, you may wish to review other programs that offer
          support. <p className="mb-0"> These programs include:</p>
          <ul className="mt-0 indentation">
            <li>
              <a href="https://www.vic.gov.au/school-readiness-funding" target="_blank" title="Link opens in a new tab" rel="noreferrer">
                School Readiness Funding
              </a>{" "}
              <i aria-hidden="true" className="pi pi-external-link"></i>{" "}
            </li>
            <li>
              <a
                href="https://www.vic.gov.au/flexible-support-packages-funded-kindergarten"
                target="_blank"
                title="Link opens in a new tab"
                rel="noreferrer">
                Flexible Support Packages
              </a>{" "}
              <i aria-hidden="true" className="pi pi-external-link"></i>{" "}
            </li>{" "}
            <li>
              <a
                href="https://www.education.gov.au/early-childhood/providers/extra-support/inclusion-support-program"
                target="_blank"
                title="Link opens in a new tab"
                rel="noreferrer">
                Inclusion Support Program
              </a>{" "}
              <i aria-hidden="true" className="pi pi-external-link"></i>{" "}
            </li>{" "}
            <li>
              <a href="https://www.vic.gov.au/preschool-field-officer-program" target="_blank" title="Link opens in a new tab" rel="noreferrer">
                Preschool Field Officer
              </a>{" "}
              <i aria-hidden="true" className="pi pi-external-link"></i>{" "}
            </li>{" "}
            <li>
              <a
                href="https://www.vic.gov.au/early-childhood-intervention-services-national-disability-insurance-scheme"
                target="_blank"
                title="Link opens in a new tab"
                rel="noreferrer">
                Early Childhood Intervention Services
              </a>{" "}
              <i aria-hidden="true" className="pi pi-external-link"></i>{" "}
            </li>{" "}
            <li>
              <a href="https://www.earlyyearshub.com.au/resources/lookout-ecla" target="_blank" title="Link opens in a new tab" rel="noreferrer">
                LOOKOUT Early Childhood Learning
              </a>{" "}
              <i aria-hidden="true" className="pi pi-external-link"></i>{" "}
            </li>{" "}
            <li>
              <a href="https://www.vic.gov.au/access-early-learning" target="_blank" title="Link opens in a new tab" rel="noreferrer">
                Access to Early Learning
              </a>{" "}
              <i aria-hidden="true" className="pi pi-external-link"></i>{" "}
            </li>{" "}
            <li>
              <a
                href="https://www.schoolbuildings.vic.gov.au/building-blocks-grants-inclusion"
                target="_blank"
                title="Link opens in a new tab"
                rel="noreferrer">
                Building Blocks Grants
              </a>{" "}
              <i aria-hidden="true" className="pi pi-external-link"></i>{" "}
            </li>{" "}
            <li>
              <a
                href="https://www.vic.gov.au/supporting-early-childhood-educator-mental-health-and-wellbeing"
                target="_blank"
                title="Link opens in a new tab"
                rel="noreferrer">
                Mental Health in Early Childhood
              </a>{" "}
              <i aria-hidden="true" className="pi pi-external-link"></i>{" "}
            </li>{" "}
          </ul>
          Your KIS Provider can also offer advice.
        </div>
      ),
    },
    label: "",
  },
  {
    type: "field",
    key: "advisory20",
    fieldType: "advisory",
    hideExpression: (context, values) =>
      !showAdvisoryTextSectionR(context, values) ||
      (values.applicationBase != null
        ? !(values.applicationBase.screeningQuestions.fundedKinder.consentYes.screeningApplicationType == 1)
        : !(values.fundedKinder.consentYes.screeningApplicationType == 1)),
    props: {
      type: "warning",
      Body: () => (
        <div className="list-none pl-2 m-0">
          {import.meta.env.VITE_NVI == "kappa" && <p>Advisory R</p>}
          However, while the child cannot be assessed for eligibility under the disability stream, the child may be eligible under the complex medical
          needs stream.
          <p>
            {" "}
            <strong>
              If you would like to continue this application, please note that the child will be assessed against the complex medical needs
              eligibility criteria only.
            </strong>
          </p>
          <p>
            {" "}
            To continue, you will need to provide some basic information about the child and your kindergarten service to create the application. Once
            these fields are completed, the KIS portal will create an application record for the child, which will display when you log into the KIS
            portal. You can come back and complete the rest of the application at any time, it does not need to be finished in one session.
          </p>
          To check what documents you may need to upload for this application, please refer to the{" "}
          <a
            href="https://www.ahaconsulting.com.au/wp-content/uploads/2025/08/Application-completion-checklist.pdf"
            target="_blank"
            title="Link opens in a new tab"
            rel="noreferrer">
            KIS application completion checklist
          </a>
          . <i aria-hidden="true" className="pi pi-external-link"></i>
        </div>
      ),
    },
    label: "",
  },
];
